import { Component, Inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  error: Error | null = null;
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth) {}

  ngOnInit(): void {
    this.login();
  }

  async login() {
    try {
      await this.oktaAuth.signInWithRedirect({ originalUri: '/' });
    } catch (err) {
      this.error = err as Error;
    }
  }

}
